// Mock data for AgentIQ platform

export const mockUser = {
  id: 'user1',
  email: 'demo@agentiq.com',
  name: 'Demo User',
  company_name: 'Demo Company',
  role: 'admin'
};

export const mockAgents = [
  { id: 'a1', name: 'Priya Sharma', agent_code: 'CS-001', team: 'Billing', role: 'Senior Agent', company_id: 'c1', created_at: '2024-01-15' },
  { id: 'a2', name: 'Rahul Mehta', agent_code: 'CS-002', team: 'Technical', role: 'Agent', company_id: 'c1', created_at: '2024-01-16' },
  { id: 'a3', name: 'Anita Nair', agent_code: 'CS-003', team: 'Billing', role: 'Agent', company_id: 'c1', created_at: '2024-01-17' },
  { id: 'a4', name: 'Kiran Patel', agent_code: 'CS-004', team: 'Shipping', role: 'Junior Agent', company_id: 'c1', created_at: '2024-01-18' },
];

export const mockSOPs = [
  {
    id: 'sop1',
    name: 'Refund Policy SOP',
    text: 'Refunds must be processed within 30 days of purchase. Agents must verify order ID before processing. Always offer store credit as an alternative. Escalate to manager if amount exceeds $500.',
    company_id: 'c1',
    created_at: '2024-01-10',
    created_by: 'user1'
  },
  {
    id: 'sop2',
    name: 'Escalation Handling SOP',
    text: 'Always maintain calm and professional tone. Acknowledge customer frustration. Offer callback within 2 hours. Transfer to manager if customer uses abusive language.',
    company_id: 'c1',
    created_at: '2024-01-12',
    created_by: 'user1'
  },
  {
    id: 'sop3',
    name: 'Technical Support SOP',
    text: 'Gather all relevant technical details before troubleshooting. Follow diagnostic flowchart. Document all steps taken. Offer remote access if needed. Create ticket for engineering if unresolved.',
    company_id: 'c1',
    created_at: '2024-01-14',
    created_by: 'user1'
  }
];

export const mockScorecards = [
  {
    id: 'sc1',
    name: 'Standard QA Scorecard',
    parameters: [
      { name: 'Greeting & Introduction', max: 10, pass: 7 },
      { name: 'Empathy & Tone', max: 20, pass: 14 },
      { name: 'Problem Understanding', max: 20, pass: 14 },
      { name: 'Resolution Quality', max: 25, pass: 18 },
      { name: 'SOP Compliance', max: 15, pass: 12 },
      { name: 'Closing & Follow-up', max: 10, pass: 7 }
    ],
    company_id: 'c1',
    created_at: '2024-01-10',
    created_by: 'user1'
  }
];

export const mockQASessions = [
  {
    id: 'qa1',
    agent_id: 'a1',
    transcript: 'Agent: Hi! How can I help you?\nCustomer: I need a refund\nAgent: I can help with that. Can you share your order number?',
    score: 85,
    grade: 'Excellent',
    parameters: [
      { name: 'Greeting & Introduction', max: 10, pass: 7, scored: 9 },
      { name: 'Empathy & Tone', max: 20, pass: 14, scored: 18 }
    ],
    sop_violations: [],
    coaching: 'Great job on maintaining empathy and following the greeting protocol.',
    source: 'manual',
    company_id: 'c1',
    created_at: '2024-01-20T10:30:00'
  },
  {
    id: 'qa2',
    agent_id: 'a2',
    transcript: 'Agent: What do you want?\nCustomer: I have a problem\nAgent: Ok tell me',
    score: 45,
    grade: 'Needs Improvement',
    parameters: [
      { name: 'Greeting & Introduction', max: 10, pass: 7, scored: 3 },
      { name: 'Empathy & Tone', max: 20, pass: 14, scored: 8 }
    ],
    sop_violations: ['Failed to provide proper greeting', 'Unprofessional tone'],
    coaching: 'Focus on professional greetings and empathetic language.',
    source: 'manual',
    company_id: 'c1',
    created_at: '2024-01-21T14:15:00'
  }
];

export const mockTrainingSessions = [
  {
    id: 'tr1',
    agent_id: 'a1',
    scenario: 'Angry customer demanding refund',
    mood: 'angry',
    score: 88,
    grade: 'Excellent',
    coaching: 'Well handled de-escalation',
    company_id: 'c1',
    created_at: '2024-01-19T09:00:00'
  },
  {
    id: 'tr2',
    agent_id: 'a3',
    scenario: 'Technical issue troubleshooting',
    mood: 'confused',
    score: 72,
    grade: 'Good',
    coaching: 'Good diagnostic approach, could improve clarity',
    company_id: 'c1',
    created_at: '2024-01-19T11:30:00'
  }
];

export const mockScenarios = [
  {
    id: 's1',
    icon: '💳',
    title: 'Refund Request',
    desc: 'Customer wants money back',
    difficulty: 'Easy',
    diffClass: 'easy',
    brief: 'Customer purchased an item 2 weeks ago and now wants a full refund. Handle according to SOP.',
    hints: ['Verify order details first', 'Check if within 30-day window', 'Offer store credit alternative']
  },
  {
    id: 's2',
    icon: '🔥',
    title: 'Escalated Complaint',
    desc: 'Angry customer demands supervisor',
    difficulty: 'Hard',
    diffClass: 'hard',
    brief: 'Customer is very upset about a delayed order and wants to speak to your manager immediately.',
    hints: ['Stay calm and professional', 'Acknowledge their frustration', 'Offer immediate solutions before escalating']
  },
  {
    id: 's3',
    icon: '🔧',
    title: 'Technical Issue',
    desc: 'Product not working properly',
    difficulty: 'Medium',
    diffClass: 'medium',
    brief: 'Customer reports their product stopped working after 1 month of use.',
    hints: ['Gather technical details', 'Follow diagnostic steps', 'Document everything']
  },
  {
    id: 's4',
    icon: '📦',
    title: 'Shipping Delay',
    desc: 'Order not arrived on time',
    difficulty: 'Easy',
    diffClass: 'easy',
    brief: 'Customer expected delivery 3 days ago but package has not arrived yet.',
    hints: ['Check tracking information', 'Provide realistic timeline', 'Offer compensation if applicable']
  },
  {
    id: 's5',
    icon: '💰',
    title: 'Billing Dispute',
    desc: 'Customer questions charges',
    difficulty: 'Medium',
    diffClass: 'medium',
    brief: 'Customer sees unexpected charges on their account and demands explanation.',
    hints: ['Review billing history', 'Explain charges clearly', 'Offer investigation if needed']
  },
  {
    id: 's6',
    icon: '🔄',
    title: 'Account Changes',
    desc: 'Customer wants to modify account',
    difficulty: 'Easy',
    diffClass: 'easy',
    brief: 'Customer wants to change their email address and payment method.',
    hints: ['Verify identity first', 'Guide through change process', 'Confirm changes made']
  }
];

export const mockStats = {
  agent_count: 4,
  avg_score: 76,
  total_sessions: 15,
  qa_sessions: 8,
  training_sessions: 7,
  need_coaching: 2,
  cert_count: 3
};
